enum FeatureFlags {
  ConfLeadCapture = 'is_lead_capture_enabled',
  ConfLeadCaptureLicenseLimit = 'lead_capture_license_limit',
  ConfInteractiveMaps = 'is_interactive_maps_enabled',
  ConfVideoLibraryEnabled = 'is_video_library_enabled',
  OnsiteAppSessionRegistration = 'onsite_app_session_registration',
  GroupRegistrationEnabled = 'group_registration_enabled',
}

export default FeatureFlags;
